import { render, staticRenderFns } from "./TextareaCodeEditor.vue?vue&type=template&id=4a577066&"
import script from "./TextareaCodeEditor.vue?vue&type=script&lang=ts&"
export * from "./TextareaCodeEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TextareaCodeEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports